import { CSSObject } from '@chakra-ui/react';

const baseFontFamily = 'accent';
const baseFontWeight = 'medium';
const baseTextColor = 'white';

export const GreenIDText: CSSObject = {
  color: 'white',
  mt: '2',
};

export const GreenIDContainer: CSSObject = {
  borderRadius: 'lg',
  '#greenid-intro-content #greenid-intro-words .lead': {
    fontFamily: 'accent',
    fontStyle: 'normal',
    fontWeight: 'medium',
    fontSize: 'xs',
    color: 'white',
    px: '10',
  },

  '#greenid-container': {
    bg: 'transparent',
    borderRadius: 'lg',
  },

  '#greenid-container .btn-primary': {
    fontSize: 'xs',
    fontFamily: 'heading',
    bgColor: 'gamma.500',
    bgGradient: 'linear(to-b, gamma.300, gamma.500)',
    boxShadow:
      '0px 3px 5px 0px rgba(0, 0, 0, 0.30), 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset',
    borderRadius: 'base',
    textColor: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    width: '100%',
    border: 'none',
    color: 'alpha.700',
    '&:focus': {
      backgroundColor: 'gamma.600',
    },
  },

  '#greenid-source-content': {
    border: 'none !important',
    px: '10',
  },

  // Source title styles
  '#greenid-source-content #greenid-source-header #greenid-source-title #greenid-source-title-heading':
    {
      fontFamily: baseFontFamily,
      fontWeight: `${baseFontWeight} !important`,
      color: baseTextColor,
    },

  // Form label styles
  '#greenid-source-body .row .form-group .control-label': {
    fontFamily: baseFontFamily,
    fontWeight: baseFontWeight,
    color: baseTextColor,
  },

  // Help icon styles
  '#greenid-source-body #greenid-FieldsForm .help-block': {
    fontFamily: baseFontFamily,
    fontWeight: baseFontWeight,
    color: baseTextColor,
  },

  '#greenid-source-content #greenid-source-header #greenid-source-title .greenid-modal-launch':
    {
      px: 0,
    },

  '#greenid-FieldsForm .control-label, #greenid-FieldsForm .greenid-helpicon, #greenid-source-title #greenid-source-title-heading, #greenid-source-title .greenid-modal-launch, #greenid-source-body .control-label':
    {
      color: 'white',
    },

  '.greenid-datepicker-container.datepicker table tr td.active.active, .greenid-datepicker-container.datepicker table tr td.active:hover.active, .greenid-datepicker-container.datepicker table tr td.active.disabled.active, .greenid-datepicker-container.datepicker table tr td.active.disabled:hover.active':
    {
      bg: 'alpha.900',
    },

  '#greenid-container #greenid-source-content #greenid-medicaredvs-multiline-name-toggle':
  {
    color: 'white',
  },
};
